$(document).ready(function(){
  $("a").click(function(event){
    var anchor = $(this).attr('href').split('#')[1];
    if(anchor){
      if(window.location.pathname !== '/') {
        window.location.href = '/#' + anchor;
        event.preventDefault();
      }
    }
  });
});
